import React from "react";

const ContactSection = () => {
  const [result, setResult] = React.useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "c93ea2de-09f0-484c-b530-7a0bd3b1a560");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Contacto</h2>
          <h3>
            <span>Contactanos</span>
          </h3>
          <p>
            ¡Estamos aquí para ayudarte! No dudes en contactarnos si tienes
            alguna pregunta o necesitas ayuda con el uso del programa.
          </p>
        </div>

        <div
          className="row d-flex justify-content-center align-items-center"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="col-lg-7">
            <form className="php-email-form w-100" onSubmit={onSubmit}>
              <span>{result}</span>
              <div className="row w-100">
                <div
                  className="col form-group w-100"
                  style={{ paddingLeft: "0px" }}
                >
                  <input
                    type="text"
                    name="name"
                    className="form-control w-100"
                    id="name"
                    placeholder="Tu nombre"
                    required
                  />
                </div>
                <div
                  className="col form-group w-100"
                  style={{ paddingRight: "0px" }}
                >
                  <input
                    type="email"
                    className="form-control w-100"
                    name="email"
                    id="email"
                    placeholder="Tu Email"
                    required
                  />
                </div>
              </div>
              <div className="form-group w-100">
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  id="subject"
                  placeholder="Asunto"
                  required
                />
              </div>
              <div className="form-group w-100">
                <textarea
                  className="form-control"
                  name="message"
                  rows="5"
                  placeholder="Mensaje"
                  required
                ></textarea>
              </div>

              <div className="text-center">
                <button type="submit">Enviar mensaje</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
